<template>
    <div class="vx-row">
      <div class="w-full vx-col">
          <!-- <vx-card  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
              <div class="vx-row">
                  <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                      <label class="text-sm opacity-100 text-bold">Code</label>
                      <vs-input type="search"  placeholder="Search.." v-model="filters['code']" class="w-full mb-4 md:mb-0"/>
                  </div>
                  <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                      <label class="text-sm opacity-100 text-bold">Name</label>
                      <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
                  </div>
              </div>
              <div class="mt-5 vx-row">
                  <div class="w-full ml-auto vx-col">
                      <vs-button class="float-right mr-4" size="small"
                                  color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
                  </div>
              </div>
          </vx-card> -->
        <vx-card :title="''" class="">
          <template slot="actions">
            <vs-button  @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
          </template>
          <div id="incoterms-table" class="vx-row" >
            <div class="w-full vx-col">
  
              <vs-table stripe sort class="mt-8" :data="incoterms">
                <template slot="thead">
                  <vs-th>NAME</vs-th>
                  <vs-th>FIELD TYPE</vs-th>
                  <vs-th>IS COMPULSARY</vs-th>
                  <vs-th>HIDDEN STATUS</vs-th>
                  <vs-th>ACTION</vs-th>
                </template>
  
                <template slot-scope="{data}">
                  <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">
  
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
  
                     <vs-td :data="data[indextr].type">
                      {{ data[indextr].type }}
                    </vs-td>

                    <vs-td :data="data[indextr].is_required">
                      {{ data[indextr].is_required ? 'Yes' : 'No' }}
                    </vs-td>

                    <vs-td :data="data[indextr].is_hidden">
                      <vs-chip :color="data[indextr].is_hidden? 'danger' : 'primary'">{{ data[indextr].is_hidden ? 'Hidden' : 'Active' }}</vs-chip>
                    </vs-td>
  
                    <vs-td :data="data[indextr].name">
                      <div class="justify-start vx-row">
                        <vx-tooltip text="View/Update" position="left">
                          <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>
  
                  </vs-tr>
                </template>
  
              </vs-table>
            
  
            </div>
          </div>
        </vx-card>
      </div>
      <CreateMergedFieldPopUp ref="createMergedFieldPopUp"/>
    </div>
  </template>
  
  <script>
    import {RepositoryFactory} from '@/repository/RepositoryFactory';
    import AddNewIncotermsPopUp from "@/components/popups/settings/incoterms/AddNewIncotermsPopUp";
    import CreateMergedFieldPopUp from '@/components/popups/crm/settings/CreateMergedFieldPopUp.vue'
  
    import Filter from '@/mixins/filter';
    import SuccessMessage from '@/mixins/SuccessMessage'
    import ErrorMessages from '@/mixins/ErrorMessages'
  
    import {defaultPagination, perPageList} from "@/constants/config";
  
    const CRMRepository = RepositoryFactory.get('crm');
    export default {
      name: "MergedFieldList",
      data() {
        return {
          incoterms: [],
          filters: {},
          page : 1,
          total: 0,
          meta : {},
          sort : '',
          perPage: defaultPagination,
          descriptionItems: perPageList,
        }
      },
      components: {
        AddNewIncotermsPopUp,
        CreateMergedFieldPopUp
      },
      methods: {
        async refreshData() {
          await this.fetchIncoterms()
        },
        async fetchIncoterms() {
          await this.$vs.loading({
            container: '#incoterms-table',
            scale: 0.45
          })
          const {data} = await CRMRepository.getCrmMergedFields()
          this.incoterms =  data.data
          this.$vs.loading.close('#incoterms-table > .con-vs-loading')
        },
        async onClickAdd() {
          await this.$refs.createMergedFieldPopUp.openPopup()
        },
        async onClickUpdate(id) {
          await this.$refs.createMergedFieldPopUp.openPopup(id)
        },
        openConfirm(id) {
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: `Confirm`,
            text: 'Are you sure you want to delete this ?',
            accept: this.onClickDelete,
            parameters: [id]
          })
        },
        async onClickDelete(params) {
        //   try {
        //     await IncotermRepository.deleteIncoterms(params[0])
        //     await this.fetchIncoterms()
        //     await this.showSuccessMessage('Incoterm Deleted!');
        //   }catch (e) {
        //       this.convertAndNotifyError(e)
        //   }
        },
        filterQueryUpdate (){
          this.fetchIncoterms()
        },
  
        handleChangePage(page) {
          this.page=page;
          this.fetchIncoterms()
        },
        handleSort(key, active) {
          if(key){
            active = (active==='desc')? "-":'';
            this.sort=active+key;
            this.fetchIncoterms()
          }
        },
        changePage(index) {
          this.perPage = this.descriptionItems[index]
        },
      },
      async mounted() {
        await this.fetchIncoterms()
      },
      mixins: [Filter, SuccessMessage, ErrorMessages],
       watch : {
        page(){
          this.fetchIncoterms()
        },
        perPage() {
          this.fetchIncoterms()
        }
      }
    }
  </script>
  
  <style scoped>
  
  </style>
  